[
  {
    "code": "PR-AJ",
    "name": "Adjuntas"
  },
  {
    "code": "PR-AD",
    "name": "Aguada"
  },
  {
    "code": "PR-AL",
    "name": "Aguadilla"
  },
  {
    "code": "PR-AB",
    "name": "Aguas Buenas"
  },
  {
    "code": "PR-AI",
    "name": "Aibonito"
  },
  {
    "code": "PR-AC",
    "name": "Arecibo"
  },
  {
    "code": "PR-AR",
    "name": "Arroyo"
  },
  {
    "code": "PR-AN",
    "name": "Añasco"
  },
  {
    "code": "PR-BC",
    "name": "Barceloneta"
  },
  {
    "code": "PR-BQ",
    "name": "Barranquitas"
  },
  {
    "code": "PR-BY",
    "name": "Bayamón"
  },
  {
    "code": "PR-CR",
    "name": "Cabo Rojo"
  },
  {
    "code": "PR-CG",
    "name": "Caguas"
  },
  {
    "code": "PR-CA",
    "name": "Camuy"
  },
  {
    "code": "PR-CV",
    "name": "Canóvanas"
  },
  {
    "code": "PR-CN",
    "name": "Carolina"
  },
  {
    "code": "PR-CT",
    "name": "Cataño"
  },
  {
    "code": "PR-CY",
    "name": "Cayey"
  },
  {
    "code": "PR-CB",
    "name": "Ceiba"
  },
  {
    "code": "PR-CL",
    "name": "Ciales"
  },
  {
    "code": "PR-CD",
    "name": "Cidra"
  },
  {
    "code": "PR-CO",
    "name": "Coamo"
  },
  {
    "code": "PR-CM",
    "name": "Comerío"
  },
  {
    "code": "PR-CZ",
    "name": "Corozal"
  },
  {
    "code": "PR-CU",
    "name": "Culebra"
  },
  {
    "code": "PR-DO",
    "name": "Dorado"
  },
  {
    "code": "PR-FJ",
    "name": "Fajardo"
  },
  {
    "code": "PR-FL",
    "name": "Florida"
  },
  {
    "code": "PR-GM",
    "name": "Guayama"
  },
  {
    "code": "PR-GL",
    "name": "Guayanilla"
  },
  {
    "code": "PR-GB",
    "name": "Guaynabo"
  },
  {
    "code": "PR-GR",
    "name": "Gurabo"
  },
  {
    "code": "PR-GC",
    "name": "Guánica"
  },
  {
    "code": "PR-HA",
    "name": "Hatillo"
  },
  {
    "code": "PR-HO",
    "name": "Hormigueros"
  },
  {
    "code": "PR-HU",
    "name": "Humacao"
  },
  {
    "code": "PR-IS",
    "name": "Isabela"
  },
  {
    "code": "PR-JY",
    "name": "Jayuya"
  },
  {
    "code": "PR-JD",
    "name": "Juana Díaz"
  },
  {
    "code": "PR-JC",
    "name": "Juncos"
  },
  {
    "code": "PR-LJ",
    "name": "Lajas"
  },
  {
    "code": "PR-LR",
    "name": "Lares"
  },
  {
    "code": "PR-LM",
    "name": "Las Marías"
  },
  {
    "code": "PR-LP",
    "name": "Las Piedras"
  },
  {
    "code": "PR-LZ",
    "name": "Loíza"
  },
  {
    "code": "PR-LQ",
    "name": "Luquillo"
  },
  {
    "code": "PR-MT",
    "name": "Manatí"
  },
  {
    "code": "PR-MR",
    "name": "Maricao"
  },
  {
    "code": "PR-MB",
    "name": "Maunabo"
  },
  {
    "code": "PR-MG",
    "name": "Mayagüez"
  },
  {
    "code": "PR-MC",
    "name": "Moca"
  },
  {
    "code": "PR-MV",
    "name": "Morovis"
  },
  {
    "code": "PR-NG",
    "name": "Naguabo"
  },
  {
    "code": "PR-NR",
    "name": "Naranjito"
  },
  {
    "code": "PR-OR",
    "name": "Orocovis"
  },
  {
    "code": "PR-PT",
    "name": "Patillas"
  },
  {
    "code": "PR-PN",
    "name": "Peñuelas"
  },
  {
    "code": "PR-PO",
    "name": "Ponce"
  },
  {
    "code": "PR-QB",
    "name": "Quebradillas"
  },
  {
    "code": "PR-RC",
    "name": "Rincón"
  },
  {
    "code": "PR-RG",
    "name": "Río Grande"
  },
  {
    "code": "PR-SB",
    "name": "Sabana Grande"
  },
  {
    "code": "PR-SA",
    "name": "Salinas"
  },
  {
    "code": "PR-SG",
    "name": "San Germán"
  },
  {
    "code": "PR-SJ",
    "name": "San Juan"
  },
  {
    "code": "PR-SL",
    "name": "San Lorenzo"
  },
  {
    "code": "PR-SS",
    "name": "San Sebastián"
  },
  {
    "code": "PR-SI",
    "name": "Santa Isabel"
  },
  {
    "code": "PR-TA",
    "name": "Toa Alta"
  },
  {
    "code": "PR-TB",
    "name": "Toa Baja"
  },
  {
    "code": "PR-TJ",
    "name": "Trujillo Alto"
  },
  {
    "code": "PR-UT",
    "name": "Utuado"
  },
  {
    "code": "PR-VA",
    "name": "Vega Alta"
  },
  {
    "code": "PR-VB",
    "name": "Vega Baja"
  },
  {
    "code": "PR-VQ",
    "name": "Vieques"
  },
  {
    "code": "PR-VL",
    "name": "Villalba"
  },
  {
    "code": "PR-YB",
    "name": "Yabucoa"
  },
  {
    "code": "PR-YU",
    "name": "Yauco"
  }
]